import { PopupOptions } from '../../ts';

export const DEFAULT_POPUP_OPTIONS: PopupOptions = {
  isOpen: false,
  isKeepOpenForced: false,
  isClickOutsideDisabled: false,
  title: '',
  children: null,
};
